<div class="promo-card-container" *ngIf="promoData$ | async">
  <fcom-promo-card
    [imageData$]="promoData$ | finMap: 'picture'"
    [data$]="promoData$"
    [ctaData$]="promoCta$"
    [aspectRatio]="'4x3'"
    [isTextOnTop]="true"
    [theme]="PromoTheme.FULL_BG"
  />
</div>
